import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function LinearWithValueLabel({ numerator, denominator, ...props }) {

    if (denominator === undefined) {
        return undefined
    }

    if (numerator === undefined) {
        numerator = 0
    }

    if (numerator < 0) {
        return undefined
    }

    if (denominator < 1) {
        denominator = 1
    }

    if (numerator > denominator) {
        return undefined
    }

    if (!props.show100 && numerator === denominator) {
        return undefined
    }


    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                    <LinearProgress variant="determinate" value={numerator / denominator * 100} />
                </Box>
                <Box sx={{ minWidth: 35 }}>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                        {`${Math.round((numerator / denominator) * 100)}%`}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}
